export default function getCharCount(text) {
  const regex = /(?:\r\n|\r|\n)/g; // new line, carriage return, line feed
  return text.replace(regex, '').length;
}
